var transformStyleMapper = {
  transform: function transform(value, _) {
    return {
      style: {
        transform: value
      }
    };
  }
};

export { transformStyleMapper };
//# sourceMappingURL=transform.js.map
